/**
 * Desktop re-exports shared chapter comment labels (web + desktop parity).
 */

export {
  CHAPTER_COMMENT_TYPE_LABELS,
  CHAPTER_COMMENT_TYPE_SET,
  CHAPTER_COMMENT_TYPE_SLUGS,
  CHAPTER_DOC_MARK_COMMENT_TYPES,
  CHAPTER_TEXT_COMMENT_TYPES,
  chapterCommentTypeClassSlug,
  formatChapterCommentTypeLabel,
  normalizeChapterCommentType,
  type ChapterCommentTypeSlug,
  type ChapterTextCommentType,
} from "./chapterCommentTypes";

/** @deprecated Use normalizeChapterCommentType */
export { normalizeChapterCommentType as normalizeDesktopCommentType } from "./chapterCommentTypes";

export const COMMENT_FILTER_ALL = "all" as const;

export const DESKTOP_CHAPTER_COMMENT_TYPES = [
  "note",
  "question",
  "suggestion",
  "issue",
  "praise",
] as const;
export type DesktopChapterCommentType = (typeof DESKTOP_CHAPTER_COMMENT_TYPES)[number];

/** Who to show in the assistant comment header (Story Craft vs human vs imported name). */
export function getChapterCommentAttribution(comment: {
  createdBy?: "user" | "ai";
  authorDisplayName?: string;
}): string {
  if (comment.createdBy === "ai") return "Story Craft";
  const name = comment.authorDisplayName?.trim();
  if (name) return name;
  return "You";
}
